import Icon from '../components/Icon.vue'

Icon.register({"file-image":{"width":384,"height":512,"paths":[{"d":"M384 121.9V128H256V0H262.1A24-24 0 0 0 279 7L377 105A24-24 0 0 0 384 121.9zM248 160C234.8 160 224 149.2 224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248zM112.5 176C139.1 176 160.5 197.5 160.5 224S139.1 272 112.5 272 64.5 250.5 64.5 224 86 176 112.5 176zM320.5 416H64.5L65 367.5 104.5 328C109.2 323.3 116.3 323.8 121 328.5L160.5 368 264.1 264.5C268.7 259.8 276.3 259.8 281 264.5L320.5 304V416z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/file-image.js
// module id = null
// module chunks = 